import { AvatarLabelGroup } from '@orn/shared-web/components/Avatar';
import Dropdown from '@orn/shared-web/components/Dropdown/Dropdown';
import { LogOutIcon } from '@orn/shared-web/icons';
import logger from '@orn/shared-web/lib/logger';
import { cx } from '@orn/shared-web/utils/cx';
import formatUserDisplayName from '@orn/shared-web/utils/formatUserDisplayName';
import * as React from 'react';
import { Button as AriaButton } from 'react-aria-components';

import { useLogout } from '../../hooks/mutations/useLogout';

import DebugAccountSubmenu from './DebugAccountSubmenu';

import type { LoggedInUser } from '../../providers/AuthProvider';

interface INavAccountCardProps {
  user: LoggedInUser;
}

const NavAccountCard = ({ user }: INavAccountCardProps) => {
  const [logout] = useLogout();

  const handleLogout = React.useCallback(async () => {
    try {
      await logout();
      window.location.href = '/';
    } catch (error) {
      logger.error('Failed to logout:', error);
    }
  }, [logout]);

  return (
    <Dropdown.Root>
      <AriaButton
        className={({ isPressed, isFocusVisible }) =>
          cx(
            'ring-secondary relative flex w-full cursor-pointer items-center gap-3 rounded-xl p-3 ring-1 ring-inset transition-colors',
            'hover:bg-primary_hover',
            (isPressed || isFocusVisible) && 'bg-primary_hover'
          )
        }
      >
        <AvatarLabelGroup
          size="md"
          src={user.avatarUrl}
          title={formatUserDisplayName(user) ?? user.name}
          subtitle={user.email}
          contrastBorder={!user.avatarUrl}
        />
      </AriaButton>

      <Dropdown.Popover placement="top">
        <Dropdown.Menu>
          <DebugAccountSubmenu />
          <Dropdown.Item icon={LogOutIcon} onAction={handleLogout}>
            Log out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  );
};

export default NavAccountCard;
